// region Cart
/**
 * OPTIMIZED_WEB_CART - Fetches a limited set of cart attributes in the response to ensure
 * optimal performance and maintain proper functionality for the cart and checkout.
 */
export const OPTIMIZED_WEB_CART = 'OPTIMIZED_WEB_CART';
// endregion
